import { Box, styled, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { fDateTime24HSeconds } from 'utils/formatTime';
import { t } from 'utils/i18n';
import { useServerTimeOffset } from 'hooks/query';
import { useLoginService } from 'services/LoginService';

const ClockContainerStyles = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.grey[200],
  padding: '4px 12px',
  borderRadius: '8px',
  color: theme.palette.grey[500],
  minWidth: '300px',
  textAlign: 'center',
  '@media(max-width: 1024px)': {
    display: 'none',
  },
}));

export const Clock = () => {
  const { isLogin } = useLoginService();
  const { offsetMs, isReady } = useServerTimeOffset(isLogin);

  // 每秒觸發一次重繪即可；時間本身在 render 當下即時算。
  // 舊做法是拿前一秒的值 +1000，分頁被瀏覽器節流時會愈走愈慢。
  const [, forceTick] = useState(0);
  useEffect(() => {
    const intervalId = setInterval(() => forceTick(tick => tick + 1), 1000);
    return () => clearInterval(intervalId);
  }, []);

  if (!isReady) return null;

  return (
    <ClockContainerStyles>
      <Typography variant="h6">
        {`${t('common.currentDate', '目前時間')}：`}
        {fDateTime24HSeconds(new Date(Date.now() + offsetMs))}
      </Typography>
    </ClockContainerStyles>
  );
};
